import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=024fe31c&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=ts&"
export * from "./auth.vue?vue&type=script&lang=ts&"
import style0 from "./auth.vue?vue&type=style&index=0&id=024fe31c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024fe31c",
  null
  
)

export default component.exports